module.exports = __webpack_public_path__ + "static/media/icon_account.d0753015.svg";